module.exports = __webpack_public_path__ + "img/instagram_icon.e869be92.png";